import qs from 'qs';

/**
 * appends utm_* tracking to passed url
 *
 * @export
 * @param {String} url URL on which to append tracking params
 * @returns {String} url with utm_* tracking params appended
 */
export function addTrackingParams(url, utmTracking) {
  return `${url}?${qs.stringify(utmTracking)}`;
}

/**
 * Urls to facilitate sharing
 *
 *
 * @private
 * @param {String} type Type of social sharing
 * @returns {String} sharing url which will be the beginning of the button link
 */
function getShareUrl(type) {
  switch (type) {
    case 'email':
      return 'mailto:?';
    case 'facebook':
      return 'https://www.facebook.com/sharer/sharer.php?';
    case 'tweet':
      return 'https://twitter.com/intent/tweet?';
    default:
      return '';
  }
}

/**
 * creates URL for sharing depending on social media type
 *
 *
 * @export
 * @param {String} shareType Type of social sharing
 * @param {String} shareProps Object of parameters that will be added to the url as a query string
 * @returns {String} URL to pass to button
 */
export function createSocialUrl(shareType, shareProps) {
  let url = '';
  if (typeof shareProps === 'object') {
    const shareUrl = getShareUrl(shareType);
    url = `${shareUrl}${qs.stringify(shareProps)}`;
  } else {
    url = shareProps;
  }
  return url;
}
